import { memo } from "react";
import { Handle, Position, NodeProps } from "@xyflow/react";
import {
  FlowEditorConditionNode,
  useAgentWorkflowStore,
} from "@/store/agentsStore";
import { useAgentWorkflowActionsStore } from "@/store/agentWorkflowActionsStore";
import { NodeWrapper } from "./NodeWrapper";
import { NodeErrorDisplay } from "./NodeErrorDisplay";
import { GitBranch } from "lucide-react";

export const ConditionNode = memo(
  ({ data, selected }: NodeProps<FlowEditorConditionNode>) => {
    const nodeData = data.node;
    const workflowVersionId = data.workflowVersionId;

    const getActionById = useAgentWorkflowActionsStore(
      (state) => state.getActionById,
    );
    const action = nodeData.actionId
      ? getActionById(nodeData.actionId)
      : undefined;

    // Look up errors from the workflow version store
    const workflowVersion = useAgentWorkflowStore((state) =>
      workflowVersionId
        ? state.getWorkflowVersionById(workflowVersionId)
        : undefined,
    );
    const nodeErrors = workflowVersion?.errors?.[nodeData.id];

    return (
      <NodeWrapper
        selected={selected}
        nodeType="condition"
        className="px-4 py-3 min-w-[220px]"
      >
        <Handle
          type="target"
          position={Position.Top}
          className="w-3 h-3 !bg-gray-400 !border-2 !border-white"
        />

        <NodeErrorDisplay errors={nodeErrors || []} />

        <div className="flex items-center gap-3">
          <div className="p-2 bg-purple-100 rounded-lg">
            <GitBranch className="w-4 h-4 text-purple-700" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-gray-900">
              {action?.name || "Condition"}
            </span>
          </div>
        </div>

        <Handle
          type="source"
          position={Position.Bottom}
          // Unlike ActionNode, ConditionNode allows multiple outgoing edges
          isConnectableStart={true}
          className="w-3 h-3 !bg-gray-400 !border-2 !border-white"
        />
      </NodeWrapper>
    );
  },
);
